import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

interface SlugRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Componente guard para garantir que rotas protegidas sempre tenham slug
 * Se não tiver slug, não força slug padrão. Deixa rotas públicas lidarem (CmsSelector)
 */
const SlugRouteGuard: React.FC<SlugRouteGuardProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    const slug = params.slug;
    
    // Se não tem slug nos parâmetros, redirecionar
    if (!slug) return;
    
    // Verificar se o slug é válido (não é uma rota especial)
    const nonSlugRoutes = ['login', 'api', 'static', 'assets', 'favicon.ico', 'manifest.json', 'robots.txt'];
    if (nonSlugRoutes.includes(slug)) return;
  }, [location.pathname, navigate, params.slug]);

  return <>{children}</>;
};

export default SlugRouteGuard;
